import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import copyText from '@utils/copy';
import ActionButton from '@common/buttons/ActionButton/ActionButton';
import iconCopy from '@assets/icons/copyGrey.svg';
import dangerIcon from '@assets/icons/dangerTriangle.svg';

import useStyles from './styles';

const GoogleSheets = ({ resource }) => {
  const classes = useStyles();

  const getLink = () =>
    resource ? `=IMPORTDATA("${resource.csv.value}")` : '';

  return (
    <div className={classes.tabBase}>
      <div className={classes.marginLeft}>
        <div>You can open parser results with Google Sheet</div>
        <div className={classes.marginTop}>
          Just copy the following link to a cell of your &nbsp;
          <a
            href="https://docs.google.com/spreadsheets/u/0/"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            Google Sheets
          </a>
        </div>
      </div>
      <div className={classes.bold}>
        <span>Document link</span>
      </div>
      <div className={classes.displayFlex}>
        <ActionButton
          icon={<img src={iconCopy} alt="iconCopy" />}
          handler={() => copyText(getLink())}
          toolTip="Copy link"
        />

        <div className={classes.linkWrapper}>
          <pre className={classes.code}>
            <code className={classes.darkBrown}>{getLink()}</code>
          </pre>
        </div>
      </div>
      <Paper className={classes.paperWrapper}>
        <div className={classes.displayFlex}>
          <img src={dangerIcon} alt="dangerIcon" />
          <span className={classes.bold}>
            &nbsp; Limitations using those formulas:
          </span>
        </div>
        <div>
          <ul>
            <li className={classes.liMargin}>
              Deleting a document from your mailbox will also remove it from
              your Google Sheet
            </li>
            <li className={classes.liMargin}>
              Google Sheets will sync the content of your sheet with your data
              source every hour or so
            </li>
          </ul>
        </div>
      </Paper>
    </div>
  );
};

GoogleSheets.propTypes = {
  resource: PropTypes.objectOf(PropTypes.any),
  setResource: PropTypes.func,
  includeServiceInfo: PropTypes.bool,
  setIncludeServiceInfo: PropTypes.func,
};

export default GoogleSheets;
